// @flow
import React, { Component } from 'react';
import { FormattedMessage, type IntlShape } from 'react-intl';

import type {
  SmartKeywordEngine,
  SmartKeywordsSettings,
} from 'state/types/catalogTypes';
import { CONFIDENCE_LEVEL, NUM_KEYWORDS } from 'util/constants';
import BulmaSlider from './BulmaSlider';
import localizedStrings from 'util/localizedStrings';

type Props = {
  engine: SmartKeywordEngine,
  handleChangeEngineCheckbox: Function,
  intl: IntlShape,
  smartKeywordsSettings: SmartKeywordsSettings,
  updateSettings: Function,
};

export default class SmartKeywordsEngineSettingsRow extends Component<Props> {
  handleChangeSlider: Function;
  getValueForSlider: Function;

  constructor() {
    super();
    this.handleChangeSlider = this.handleChangeSlider.bind(this);
    this.getValueForSlider = this.getValueForSlider.bind(this);
  }

  getValueForSlider(key: string): number {
    const { engine, smartKeywordsSettings } = this.props;
    let result: number = 0;
    if (smartKeywordsSettings.engineSettings) {
      const engineSpecificSettings = smartKeywordsSettings.engineSettings.find(
        es => es.name === engine.token
      );
      if (engineSpecificSettings && engineSpecificSettings[key]) {
        result = engineSpecificSettings[key];
      }
    }
    result = result || smartKeywordsSettings[key];
    if (key === CONFIDENCE_LEVEL) {
      result *= 100;
    }
    return result;
  }

  handleChangeSlider(value: number, id: string) {
    const { engine, smartKeywordsSettings, updateSettings } = this.props;
    id = id.split(':')[0];

    if (id === CONFIDENCE_LEVEL) {
      value /= 100;
    }

    const newSettings = { ...smartKeywordsSettings };

    // we might need to create the engineSettings array
    if (!newSettings.engineSettings) {
      newSettings.engineSettings = [];
    }
    // we might need to create a new engine-specific settings object
    const indexOfEngineSettings = newSettings.engineSettings.findIndex(
      es => es.name === engine.token
    );
    if (indexOfEngineSettings === -1) {
      newSettings.engineSettings.push({
        name: engine.token,
        [id]: value,
      });
    } else {
      newSettings.engineSettings[indexOfEngineSettings][id] = value;
    }
    updateSettings(newSettings);
  }

  render() {
    const {
      engine,
      handleChangeEngineCheckbox,
      smartKeywordsSettings,
    } = this.props;
    const enginesEnabled = smartKeywordsSettings.engines;
    const enabled = smartKeywordsSettings.enabled;
    const numKeywords = this.getValueForSlider(NUM_KEYWORDS);
    const confidenceLevel = this.getValueForSlider(CONFIDENCE_LEVEL);
    return (
      <div className="columns" key={engine.token}>
        <div className="column is-one-third">
          <div className="field" style={{ minHeight: '40px' }}>
            <div className="control">
              <input
                className="is-checkradio"
                data-test-name={'skEngine-' + engine.token}
                disabled={!enabled}
                id={engine.token}
                type="checkbox"
                checked={enginesEnabled.includes(engine.token)}
                onChange={handleChangeEngineCheckbox}
              />
              <label htmlFor={engine.token}>
                <FormattedMessage {...localizedStrings[engine.token]} />
              </label>
            </div>
          </div>
        </div>
        <div className="column is-one-third">
          {enginesEnabled.includes(engine.token) && (
            <BulmaSlider
              disabled={!enabled}
              id={`${NUM_KEYWORDS}:${engine.token}`}
              initialValue={numKeywords}
              min={1}
              max={20}
              onChange={this.handleChangeSlider}
            />
          )}
        </div>
        <div className="column is-one-third">
          {enginesEnabled.includes(engine.token) && (
            <BulmaSlider
              disabled={!enabled}
              id={`${CONFIDENCE_LEVEL}:${engine.token}`}
              initialValue={confidenceLevel}
              onChange={this.handleChangeSlider}
              min={1}
              max={100}
            />
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/SmartKeywordsEngineSettingsRow.js